import InfoWithTooltip from './InfoWithTooltip';
import RectText from '../../../../../../../../components/Text/RectText';

const StudentCurriculumProgress = ({
  studyPlanEnrollmentId,
  curriculumProgressAvg,
  texts,
}: {
  studyPlanEnrollmentId: number;
  curriculumProgressAvg: number | null;
  texts: {
    CurriculumProgressTooltip: string;
    CurriculumProgress: string;
  };
}) => {
  return (
    <p
      className="d-flex align-items-center justify-content-start"
      style={{ gap: '8px' }}
    >
      <b>{texts.CurriculumProgress}:</b>
      <RectText text={curriculumProgressAvg} opacity={0.8} />
      <InfoWithTooltip
        show
        tooltipId={`${studyPlanEnrollmentId}-tooltip`}
        tooltipText={texts.CurriculumProgressTooltip}
      />
    </p>
  );
};

export default StudentCurriculumProgress;
